/********************************
 编码/解码工具函数
 ********************************/


function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

function atobPolyfill(input: string) {
    // 对字符串进行解码的函数
    const keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let output = '';
    let chr1, chr2, chr3;
    let enc1, enc2, enc3, enc4;
    let i = 0;

    // 替换掉输入字符串中的所有不属于base-64范围的字符
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

    while (i < input.length) {
        enc1 = keyStr.indexOf(input.charAt(i++));
        enc2 = keyStr.indexOf(input.charAt(i++));
        enc3 = keyStr.indexOf(input.charAt(i++));
        enc4 = keyStr.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        output = output + String.fromCharCode(chr1);

        if (enc3 !== 64) {
            output = output + String.fromCharCode(chr2);
        }
        if (enc4 !== 64) {
            output = output + String.fromCharCode(chr3);
        }
    }

    // 返回解码后的字符串
    return output;
}



/**
 * 生成一个随机的UUID。
 * @returns 返回一个随机生成的UUID字符串。
 */
export function randomChallenge() {
    return crypto.randomUUID()
    // return generateUUID();
}

/**
 * 将字符串转换为ArrayBuffer。
 * @param txt 需要转换的字符串。
 * @returns 返回转换后的ArrayBuffer。
 */
export function toBuffer(txt :string) :ArrayBuffer {
    return Uint8Array.from(txt, c => c.charCodeAt(0)).buffer
}

/**
 * 将ArrayBuffer解析为字符串。
 * @param buffer 需要解析的ArrayBuffer。
 * @returns 返回解析后的字符串。
 */
export function parseBuffer(buffer :ArrayBuffer) :string {
    return String.fromCharCode(...new Uint8Array(buffer))
}

/**
 * 检查字符串是否为Base64url编码。
 * @param txt 需要检查的字符串。
 * @returns 如果是Base64url编码则返回true，否则返回false。
 */
export function isBase64url(txt :string) :boolean {
    return txt.match(/^[a-zA-Z0-9\-_]+=*$/) !== null
}

/**
 * 将ArrayBuffer转换为Base64url编码的字符串。
 * @param buffer 需要转换的ArrayBuffer。
 * @returns 返回转换后的Base64url字符串。
 */
export function toBase64url(buffer :ArrayBuffer) :string {
    if (!String.prototype.replaceAll) {
        String.prototype.replaceAll = function(search, replacement: any) {
            // 如果 search 是一个字符串，需要转义正则表达式的特殊字符
            if (typeof search === 'string') {
                search = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            }

            // 确保 search 是一个全局的正则表达式
            var regExp = new RegExp(search, 'g');

            // 使用 replace 方法进行全局替换
            return this.replace(regExp, replacement);
        };
    }
    // const txt = btoa(parseBuffer(buffer)) // 转换为base64
    const txt = btoa(parseBuffer(buffer)) // 转换为base64
    return txt.replaceAll('+', '-').replaceAll('/', '_') // 转换为base64url
}

/**
 * 将Base64url编码的字符串解析为ArrayBuffer。
 * @param txt 需要解析的Base64url字符串。
 * @returns 返回解析后的ArrayBuffer。
 */
// export function parseBase64url(txt :string) :ArrayBuffer {
//     if (!String.prototype.replaceAll) {
//         String.prototype.replaceAll = function(search, replacement: any) {
//             // 如果 search 是一个字符串，需要转义正则表达式的特殊字符
//             if (typeof search === 'string') {
//                 search = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
//             }
//
//             // 确保 search 是一个全局的正则表达式
//             var regExp = new RegExp(search, 'g');
//
//             // 使用 replace 方法进行全局替换
//             return this.replace(regExp, replacement);
//         };
//     }
//     txt = txt.replaceAll('-', '+').replaceAll('_', '/') // 转换为base64
//     return toBuffer(atobPolyfill(txt)) // 解码为ArrayBuffer
// }

export function parseBase64url(txt :string) :ArrayBuffer {
    if (!String.prototype.replaceAll) {
        String.prototype.replaceAll = function(search, replacement: any) {
            // 如果 search 是一个字符串，需要转义正则表达式的特殊字符
            if (typeof search === 'string') {
                search = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            }

            // 确保 search 是一个全局的正则表达式
            var regExp = new RegExp(search, 'g');

            // 使用 replace 方法进行全局替换
            return this.replace(regExp, replacement);
        };
    }
    txt = txt.replaceAll('-', '+').replaceAll('_', '/') // 转换为base64
    return toBuffer(atob(txt)) // 解码为ArrayBuffer
}

/**
 * 使用SHA-256算法计算给定ArrayBuffer的哈希值。
 * @param buffer 需要计算哈希值的ArrayBuffer。
 * @returns 返回计算得到的SHA-256哈希值的ArrayBuffer。
 */
export async function sha256(buffer :ArrayBuffer) :Promise<ArrayBuffer> {
    return await window.crypto.subtle.digest('SHA-256', buffer)
}

/**
 * 将ArrayBuffer转换为16进制字符串。
 * @param buffer 需要转换的ArrayBuffer。
 * @returns 返回转换后的16进制字符串。
 */
export function bufferToHex (buffer :ArrayBuffer) :string {
    if (!String.prototype.padStart) {
        String.prototype.padStart = function padStart(targetLength: number, padString: string) {
            targetLength = Math.floor(targetLength);
            if (this.length >= targetLength) {
                return String(this);
            }

            padString = padString !== undefined ? String(padString) : ' ';
            if (padString === '') {
                padString = ' ';
            }

            var pad = '';
            var padLength = targetLength - this.length;
            while (pad.length < padLength) {
                pad += padString.length > 1 ? padString.substring(0, padLength - pad.length) : padString;
            }

            return pad.substring(0, padLength) + String(this);
        };
    }
    return [...new Uint8Array (buffer)]
        .map (b => b.toString (16).padStart (2, "0"))
        .join ("");
}

/**
 * 连接两个ArrayBuffer。
 * @param buffer1 第一个ArrayBuffer。
 * @param buffer2 第二个ArrayBuffer。
 * @returns 返回连接后的ArrayBuffer。
 */
export function concatenateBuffers(buffer1 :ArrayBuffer, buffer2  :ArrayBuffer) {
    var tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
    tmp.set(new Uint8Array(buffer1), 0);
    tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
    return tmp;
};
